import { ISmartSendContext } from '../context/SmartSendContextModels';
import GenerateOptions from './SmartSendBulkActionOptions';
import { GetSelectedItems } from './GetSelectedItems';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';

export function GetBookableBasedOnSelection(
  filterKey: string,
  state: ISmartSendContext,
  smartSendItemsCache: SmartSendItemApiModel[]
): SmartSendItemApiModel[] {
  return GetSelectedItems(filterKey, state, smartSendItemsCache).filter((i) =>
    GenerateOptions(i, i.State.validation).includes('Book')
  );
}
